import { render, staticRenderFns } from "./MaterialsPage.vue?vue&type=template&id=6cefb354&scoped=true"
import script from "./MaterialsPage.vue?vue&type=script&lang=ts"
export * from "./MaterialsPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialsPage.vue?vue&type=style&index=0&id=6cefb354&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cefb354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cefb354')) {
      api.createRecord('6cefb354', component.options)
    } else {
      api.reload('6cefb354', component.options)
    }
    module.hot.accept("./MaterialsPage.vue?vue&type=template&id=6cefb354&scoped=true", function () {
      api.rerender('6cefb354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/MaterialsPage.vue"
export default component.exports